import HeadingComponent from "../UserInterface/HeadingComponent";
import { BlockComponent } from "../UserInterface/BlockComponent";
import { DataAwards } from "../../data/DataAwards";
import Description from "../UserInterface/Description";
import LayoutCenter from "../UserInterface/LayoutCenter";

const AwardsBlocks = () => {
  return (
    <div>
      <HeadingComponent headingText="Penghargaan Kami"></HeadingComponent>
      <div className="awards-blocks-wrapper">
        <LayoutCenter column>
          <Description
            font="Roboto"
            text="Setiap harinya, kami memberikan yang terbaik untuk menjadikan semua yang bermakna dalam hidup pelanggan di dalam jangkauan. Kami lakukan ini dengan terus berinovasi dan mengembangkan layanan kami."
          ></Description>
          <Description
            font="Roboto"
            text="Terima kasih atas apresiasi yang diberikan pada usaha kami. Melangkah maju, kami ingin terus membantu pelanggan kami untuk mewujudkan harapan mereka, dengan layanan pembiayaan yang aman dan terpercaya."
          ></Description>
        </LayoutCenter>

        <div className="awards-blocks-container">
          {DataAwards.map((data, key) => {
            return (
              <BlockComponent
                name={data.name}
                icon={data.image}
                items={data.items}
                key={key}
              ></BlockComponent>
            );
          })}
        </div>
      </div>
      <style jsx>{`
        .awards-blocks-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .awards-blocks-container {
          max-width: 940px;
          width: 100%;
          margin: 16px;
          grid-column-gap: 10px;
          grid-row-gap: 10px;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          justify-items: center;
        }
        @media only screen and (max-width: 700px) {
          .awards-blocks-container {
            grid-template-columns: 1fr 1fr;
          }
        }
        @media only screen and (max-width: 600px) {
          .awards-blocks-container {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default AwardsBlocks;
